module.exports = "/_next/static/images/stripe2-7871f2b951f38c6c7a60f99e0e8920a2.png";